"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
function Card({ children, className, testId, onClick, }) {
    return (react_1.default.createElement("div", { "data-testid": testId, className: (0, classnames_1.default)('bg-surface-subdued', 'border border-borderColor', 'p-6', 'rounded-lg', className), onClick: onClick }, children));
}
exports.Card = Card;
//# sourceMappingURL=Card.js.map